var _module_exports = "<div class=\"jumbotron sf-fill-extents sf-crossdomain-message-div\">\n    <h3>Redirecting&hellip;</h3>\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/app/crossdomain/crossDomainAuth.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;